import { mdiCheck } from '@mdi/js'
import { AppIcon } from '../ui/icon'

const TAG_COLORS = [
    '#ef4444', '#f97316', '#f59e0b', '#84cc16',
    '#22c55e', '#14b8a6', '#06b6d4', '#3b82f6',
    '#6366f1', '#8b5cf6', '#d946ef', '#ec4899',
]

interface TagColorPickerProps {
    value?: string
    onChange: (color: string) => void
}

export function TagColorPicker({ value, onChange }: TagColorPickerProps) {
    return (
        <div data-testid="tag-color-picker" className="flex flex-wrap gap-2">
            {TAG_COLORS.map((color) => (
                <button
                    key={color}
                    type="button"
                    data-testid={`tag-color-${color.replace('#', '')}`}
                    className="h-6 w-6 rounded-full border-2 flex items-center justify-center transition-transform hover:scale-110"
                    style={{
                        backgroundColor: color,
                        borderColor: value === color ? 'var(--foreground)' : 'transparent',
                    }}
                    onClick={() => onChange(color)}
                >
                    {value === color && <AppIcon path={mdiCheck} size="xs" className="text-white" />}
                </button>
            ))}
        </div>
    )
}
